export const CurrencyBadgeConfig = {
  type: 'white',
  label: '$',
  rightIcon: false,
  icon: '',
};

export const UnitBadgeConfig = {
  type: 'white',
  label: 'unit',
  rightIcon: false,
  icon: '',
};

export const TaxBadgeConfig = {
  type: 'white',
  label: '%',
  rightIcon: false,
  icon: '',
};
